export default __webpack_public_path__ + "5ed7a4ccf9d51f4609f570444191e2b6.png";